import { Unformatted } from '../../../utils/value.js'
import type * as Style from '../../index.js'
import { Set } from '../../index.js'
import { Length } from '../../values/index.js'
import { Reference } from '../basic/breakpoint.js'
import { VariantReference } from '../basic/font.js'

export const normalizeReusableTypographySize = (props: any = {}) => ({
  fontSize: props.fontSize === null || props.fontSize === undefined ? null : Length(props.fontSize),
  lineHeight: props.lineHeight === null || props.lineHeight === undefined ? null : Length(props.lineHeight),
  letterSpacing: props.letterSpacing === null || props.letterSpacing === undefined ? null : Length(props.letterSpacing),
  paragraphSpacing:
    props.paragraphSpacing === null || props.paragraphSpacing === undefined ? null : Length(props.paragraphSpacing),
  iconSize: props.iconSize === null || props.iconSize === undefined ? null : Length(props.iconSize)
})

export const Size = (props?: Unformatted<Size>) => normalizeReusableTypographySize(props)
export type Size = ReturnType<typeof normalizeReusableTypographySize>

Size.isValid = (props: Size) =>
  props.fontSize?.value !== null ||
  props.lineHeight?.value !== null ||
  props.letterSpacing?.value !== null ||
  props.paragraphSpacing?.value !== null ||
  props.iconSize?.value !== null

export const Props = (props: any = {}) => ({
  fontVariant: props.fontVariant || null,
  allowBoldAndItalic: !!props.allowBoldAndItalic,
  textTransform: props.textTransform,
  base: Size(props.base),
  overrides: Object.keys(props.overrides || {}).reduce((object, breakpoint: Reference) => {
    const normalized = Size(props.overrides[breakpoint])

    if (Size.isValid(normalized) && breakpoint !== 'new') {
      return Object.assign(object, { [breakpoint]: normalized })
    }

    return object
  }, {} as Record<Reference, Size>)
})

export const fix = (props: Props, styles: Style.Rule[]): Props => ({
  ...props,
  fontVariant: VariantReference.Fix(props.fontVariant, styles)
})
export const validate = () => true
export type Props = ReturnType<typeof Props>
export const label = 'Typography'
export const type = 'typography'
export const property = 'typographyIds'
export const category = 'aspect'
export const forms = [
  {
    id: 'typographyType',
    label: 'Font',
    extractProperties: ({ fontVariant }: Props) => ({
      fontVariant
    }),
    validate: ({ fontVariant }: Partial<Props>) => true
  },
  {
    id: 'typographySize',
    label: 'Settings',
    extractProperties: (props: Props) => ({ base: Size(props.base) }),
    validate: (props: Props) => Size.isValid(props.base)
  }
]
export const summarize = (props: Props, styles?: Style.Rule[], formId?: string) => {
  const font = Set.findByTypeAndId(styles || [], 'font', props.fontVariant?.id)
  switch (formId) {
    case 'typographyType':
      return font?.props.familyName || 'Inherit'
    case 'typographySize':
      return props.base.fontSize ? props.base.fontSize.value + props.base.fontSize.unit : 'Inherit'
    default:
      return font?.props.familyName || 'Inherit'
  }
}
